import { useState } from "react";
import api from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading } from "@/components/common";
import { Image as ImageIcon, Sparkle, Spinner, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Thumbnails() {
  const { data: eps, loading } = useFetch("/episodes");
  const [text, setText] = useState("Baby Dinosaur Adventure!");
  const [busy, setBusy] = useState(false);
  const [variants, setVariants] = useState([]);
  const [used, setUsed] = useState(null);

  const generate = async () => {
    setBusy(true); setVariants([]);
    try {
      const { data } = await api.post("/ai/image", { prompt: `YouTube thumbnail for a children's cartoon episode. Bold title text idea "${text}". Bright, high-contrast, expressive characters, exciting composition.`, variations: 3 });
      setVariants(data.images);
      if (data.images.some((i) => i.image)) toast.success("Thumbnails generated");
      else toast.error("Generation failed");
    } catch { toast.error("Generation failed"); }
    finally { setBusy(false); }
  };

  if (loading) return <Loading />;

  return (
    <div>
      <PageHeader icon={ImageIcon} title="Thumbnail Studio"
        subtitle="Studio AI proposes multiple thumbnails with real image generation. Track which thumbnail was used for each video and store A/B test results." />

      <Panel className="mb-6">
        <div className="flex flex-col sm:flex-row gap-3">
          <input data-testid="thumb-text" value={text} onChange={(e) => setText(e.target.value)}
            placeholder="Thumbnail hook text" className="flex-1 rounded-xl bg-black/30 border border-white/10 px-4 py-3 text-white outline-none focus:border-[#00E5FF]/50" />
          <button data-testid="thumb-generate" onClick={generate} disabled={busy}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-magic px-5 py-3 font-semibold text-black hover:opacity-90 transition-opacity disabled:opacity-60">
            {busy ? <Spinner size={18} className="animate-spin" /> : <Sparkle size={18} weight="fill" />} Generate Variants
          </button>
        </div>
      </Panel>

      {(busy || variants.length > 0) && (
        <div className="grid sm:grid-cols-3 gap-4 mb-8">
          {(busy ? [0, 1, 2] : variants).map((v, i) => (
            <div key={i} data-testid={`thumb-${i}`} className={`relative rounded-xl overflow-hidden border ${used === i ? "border-[#00FF9D] magic-glow" : "border-white/8"}`}>
              <div className="aspect-video bg-[#0e0e0e] flex items-center justify-center">
                {busy ? <Spinner size={24} className="animate-spin text-zinc-600" /> : v.image ? <img src={v.image} alt="" className="h-full w-full object-cover" /> : <span className="text-xs text-[#FF3366]">failed</span>}
              </div>
              {!busy && v.image && (
                <button onClick={() => { setUsed(i); toast.success("Set as video thumbnail"); }}
                  className={`absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${used === i ? "bg-[#00FF9D] text-black" : "glass text-white"}`}>
                  {used === i ? <><Check size={12} weight="bold" /> Used</> : "Use this"}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
